// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import Api from '@op/opds.api-base';

class RestApi {
    private readonly api: Api;
    private readonly config: any;

    constructor() {
        this.api = new Api(window.ESERVICE_REST_URL);
        this.config = {
            headers: {
                'Accept-Language': this.getLocale(),
            },
        };
    }

    private getLocale(): string {
        const attribute = document.documentElement.getAttribute('lang');
        return attribute === null ? 'fi' : attribute.substring(0, 2).toLowerCase();
    }

    public get(rest: string) {
        return this.api.get(rest, this.config);
    }

    public put(rest: string, body?: any) {
        return this.api.put(rest, { body });
    }

    public delete(rest: string) {
        return this.api.delete(rest, this.config);
    }
}

const client = new RestApi();
export default client;
